import LabeledBox from "../components/LabeledBox";

// --- Input Component ---
type InputType = "text" | "textarea" | "select";

interface MyInputFieldProps {
    disabled?:boolean;
    label: string;
    name: string;
    value: any;
    rows?: number;
    type?: InputType;
    options?: string[];
    onChange: (
        e: React.ChangeEvent<
            HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
        >
    ) => void;
}

export function MyInputField({
    disabled,
    label,
    name,
    value,
    rows,
    onChange,
    type = "text",
    options = [],
}: MyInputFieldProps) {

    return <LabeledBox label={label}>
        {type === "textarea" ? (
                <textarea
                    rows={rows}
                    name={name}
                    value={value}
                    onChange={onChange}
                    className="w-full p-2 border border-gray-200 dark:border-gray-800 rounded-md focus:border-blue-500 h-28"
                />
            ) : type === "select" ? (
                <select
                    name={name}
                    value={value}
                    onChange={onChange}
                    className="w-full p-2 border border-gray-200 dark:border-gray-800 rounded-md focus:border-blue-500"
                >
                    {options.map((op) => (
                        <option key={op} value={op}>
                            {op}
                        </option>
                    ))}
                </select>
            ) : (
                <input
                    disabled={disabled}
                    type="text"
                    name={name}
                    value={value}
                    onChange={onChange}
                    className="w-full p-2 border border-gray-200 dark:border-gray-800 rounded-md focus:border-blue-500"
                />
            )}
    </LabeledBox>

}